/* eslint-disable react/jsx-indent */
import React from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (isPrivate) {
          if (user) {
            return (user.type === 'advertiser' && user.plan) ||
              user.type === 'adm' ? (
              <Component />
            ) : (
              <Redirect
                to={{
                  pathname: 'signup',
                  state: { from: location },
                }}
              />
            );
          }
          return (
            <Redirect
              to={{
                pathname: 'signup',
                state: { from: location },
              }}
            />
          );
        }

        return <Component />;
      }}
    />
  );
};

export default Route;
